import { Translation } from "../i18n-types";

const cz: Translation = {
    "state-is-required": "State is required field.",
    description: {
        "show-more": "Zobrazit více",
        "show-less": "Ukaž méně"
    },
    footer: {
        "why-shop-with-us": "Prečo, podľa Vašich slov, nakuppovať u nás?",
        "heureka-image-url": "/footer/img/cz/comparator.png",
        benefits: {
            first: "super rýchle dodanie",
            second: "veľmi rýchly a spoľahlivý servis",
            third: "priateľský prístup zákazníckej podpory"
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.hu%2F&amp;tabs&amp;width=340&amp;height=130&amp;small_header=false&amp;adapt_container_width=true&amp;hide_cover=false&amp;show_facepile=true&amp;appId=1940300579442646",
            "facebook-page-url": "",
            "instagram-page-url": "",
            "youtube-page-url": ""
        },
        "your-foxigy-image-link": "/footer/img/cz/your-foxigy.png"
    }
};

export default cz;
